// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.wrapper {
  width: 100%;
  box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.031372549);
  height: 100%;
  overflow: auto;
  padding: 45px 15px 25px;
}

ion-img {
  width: 50px;
}

.title {
  font-family: BricolageGrotesque;
  font-size: 20px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: uppercase;
  color: #222222;
  margin-bottom: 25px;
}

.cross {
  position: absolute;
  top: 20px;
  right: 20px;
  height: 25px;
  width: 25px;
  padding: 3px;
}

ul {
  list-style-type: none;
  padding: 0px;
  padding-bottom: 50px;
}

li {
  display: flex;
  align-items: center;
  justify-content: space-between;
  text-decoration: none;
}
li .item-wrapper {
  padding: 12px 15px;
  background: #fff;
  margin-bottom: 5px;
  width: 100%;
  border: 1px solid #e8e8df;
  border-radius: 9px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
@media (max-width: 992px) {
  li .item-wrapper {
    padding-block: 9px;
  }
}
li .item-wrapper .info_block {
  border-radius: 20px;
  display: flex;
  align-items: center;
}
li .item-wrapper .info_block p {
  font-family: AppFont;
  font-size: 14px;
  line-height: 120%;
  letter-spacing: 0%;
  vertical-align: middle;
  text-transform: capitalize;
}
li .item-wrapper .info_block ion-img {
  width: 26px;
  height: 26px;
  border-radius: 50%;
  overflow: hidden;
  margin-right: 10px;
}
li .item-wrapper .circle {
  width: 20px;
  height: 20px;
  content: " ";
  border: 1px solid rgba(112, 113, 115, 0.6);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
li .item-wrapper .circle:has(.selected) {
  border: 2px solid #9E5F2C;
}
li .item-wrapper .circle .cirle_inner {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 13.2px;
  height: 13.2px;
  content: " ";
  background: transparent;
  border-radius: 50%;
}
li .item-wrapper .circle .cirle_inner.selected {
  background: #9E5F2C;
  border-radius: 50;
  transition: ease-in-out 0.3s;
}

.line-border {
  padding: 0px 20px;
}
.line-border ion-icon {
  fill: white;
  width: 100%;
}

.footer-item {
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 0px;
  padding: 20px 15px;
  display: flex;
  justify-content: center;
}
.footer-item ion-button {
  width: 100%;
  --background: #2D69AA;
}`, "",{"version":3,"sources":["webpack://./src/app/components/select-language-modal/select-language-modal.component.scss","webpack://./src/theme/mixins.scss"],"names":[],"mappings":"AAKA;EACC,WAAA;EAEA,uDAAA;EACA,YAAA;EACA,cAAA;EACA,uBAAA;AALD;;AAQA;EACC,WAAA;AALD;;AAQA;EACC,+BAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,yBAAA;EACA,cAAA;EACA,mBAAA;AALD;;AAQA;EACC,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,WAAA;EACA,YAAA;AALD;;AAQA;EACC,qBAAA;EACA,YAAA;EACA,oBAAA;AALD;;AAOA;EACC,aAAA;EACA,mBAAA;EACA,8BAAA;EAEA,qBAAA;AALD;AAOC;EACC,kBAAA;EACA,gBAAA;EAEA,kBAAA;EAEA,WAAA;EACA,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;AAPF;AC/CE;ED2CD;IAcE,kBAAA;EAND;AACF;AAOE;EACC,mBAAA;EACA,aAAA;EACA,mBAAA;AALH;AAMG;EACC,oBAAA;EACA,eAAA;EACA,iBAAA;EACA,kBAAA;EACA,sBAAA;EACA,0BAAA;AAJJ;AAMG;EACC,WAAA;EACA,YAAA;EACA,kBAAA;EACA,gBAAA;EACA,kBAAA;AAJJ;AAOE;EACC,WAAA;EACA,YAAA;EACA,YAAA;EACA,0CAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,kBAAA;AALH;AAOG;EAEC,yBAAA;AANJ;AASG;EACC,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EAEA,aAAA;EACA,cAAA;EACA,YAAA;EACA,uBAAA;EACA,kBAAA;AARJ;AAUI;EAEC,mBAAA;EACA,iBAAA;EACA,4BAAA;AATL;;AAeA;EACC,iBAAA;AAZD;AAaC;EACC,WAAA;EACA,WAAA;AAXF;;AAcA;EACC,eAAA;EACA,SAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,aAAA;EACA,uBAAA;AAXD;AAYC;EACC,WAAA;EACA,qBAAA;AAVF","sourcesContent":["@import '../../../theme/mixins';\n\n:host {\n}\n\n.wrapper {\n\twidth: 100%;\n\t// background: #f2f2f2;\n\tbox-shadow: 0px 4px 10px 0px #00000008;\n\theight: 100%;\n\toverflow: auto;\n\tpadding: 45px 15px 25px;\n}\n\nion-img {\n\twidth: 50px;\n}\n\n.title {\n\tfont-family: BricolageGrotesque;\n\tfont-size: 20px;\n\tline-height: 120%;\n\tletter-spacing: 0%;\n\tvertical-align: middle;\n\ttext-transform: uppercase;\n\tcolor: #222222;\n\tmargin-bottom: 25px;\n}\n\n.cross {\n\tposition: absolute;\n\ttop: 20px;\n\tright: 20px;\n\theight: 25px;\n\twidth: 25px;\n\tpadding: 3px;\n}\n\nul {\n\tlist-style-type: none;\n\tpadding: 0px;\n\tpadding-bottom: 50px;\n}\nli {\n\tdisplay: flex;\n\talign-items: center;\n\tjustify-content: space-between;\n\n\ttext-decoration: none;\n\n\t.item-wrapper {\n\t\tpadding: 12px 15px;\n\t\tbackground: #fff;\n\n\t\tmargin-bottom: 5px;\n\n\t\twidth: 100%;\n\t\tborder: 1px solid #e8e8df;\n\t\tborder-radius: 9px;\n\t\tdisplay: flex;\n\t\talign-items: center;\n\t\tjustify-content: space-between;\n\n\t\t@include mobile {\n\t\t\tpadding-block: 9px;\n\t\t}\n\t\t.info_block {\n\t\t\tborder-radius: 20px;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tp {\n\t\t\t\tfont-family: AppFont;\n\t\t\t\tfont-size: 14px;\n\t\t\t\tline-height: 120%;\n\t\t\t\tletter-spacing: 0%;\n\t\t\t\tvertical-align: middle;\n\t\t\t\ttext-transform: capitalize;\n\t\t\t}\n\t\t\tion-img {\n\t\t\t\twidth: 26px;\n\t\t\t\theight: 26px;\n\t\t\t\tborder-radius: 50%;\n\t\t\t\toverflow: hidden;\n\t\t\t\tmargin-right: 10px;\n\t\t\t}\n\t\t}\n\t\t.circle {\n\t\t\twidth: 20px;\n\t\t\theight: 20px;\n\t\t\tcontent: ' ';\n\t\t\tborder: 1px solid #70717399;\n\t\t\tborder-radius: 50%;\n\t\t\tdisplay: flex;\n\t\t\talign-items: center;\n\t\t\tjustify-content: center;\n\t\t\tposition: relative;\n\n\t\t\t&:has(.selected) {\n\t\t\t\t// border: 2px solid var(--ion-color-primary);\n\t\t\t\tborder: 2px solid #9E5F2C;\n\t\t\t}\n\n\t\t\t.cirle_inner {\n\t\t\t\tposition: absolute;\n\t\t\t\ttop: 50%;\n\t\t\t\tleft: 50%;\n\t\t\t\ttransform: translate(-50%, -50%);\n\n\t\t\t\twidth: 13.2px;\n\t\t\t\theight: 13.2px;\n\t\t\t\tcontent: ' ';\n\t\t\t\tbackground: transparent;\n\t\t\t\tborder-radius: 50%;\n\n\t\t\t\t&.selected {\n\t\t\t\t\t//background: var(--ion-color-primary);\n\t\t\t\t\tbackground: #9E5F2C;\n\t\t\t\t\tborder-radius: 50;\n\t\t\t\t\ttransition: ease-in-out 0.3s;\n\t\t\t\t}\n\t\t\t}\n\t\t}\n\t}\n}\n.line-border {\n\tpadding: 0px 20px;\n\tion-icon {\n\t\tfill: white;\n\t\twidth: 100%;\n\t}\n}\n.footer-item {\n\tposition: fixed;\n\tleft: 0px;\n\tright: 0px;\n\tbottom: 0px;\n\tpadding: 20px 15px;\n\tdisplay: flex;\n\tjustify-content: center;\n\tion-button {\n\t\twidth: 100%;\n\t\t--background: #2D69AA;\n\t}\n}\n","@mixin desktop {\n  @media (min-width: 991px) {\n    @content;\n  }\n}\n\n@mixin mobile {\n  @media (max-width: 992px) {\n    @content\n  }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
